import React, { forwardRef, useEffect, useState, useRef } from "react";
import LoadingImage from "../../../assets/media/loader.gif";
import Nav from "../nav";
import Header from "../../../common/header/header";
import {
  baseUrl,
  modal_chart_icon,
  modal_excel_icon,
  modal_table_icon,
} from "../../../api/baseUrl";
import Search2 from "./search2";
import {
  SegmentedControl,
  Loader as MantineLoader,
  MultiSelect,
  Button,
  Group,
  Avatar,
  Text,
  Select,
} from "@mantine/core";
import { YearPickerInput } from "@mantine/dates";
import { IconChevronDown, IconCalendar, IconSearch } from "@tabler/icons-react";
import { useCookies } from "react-cookie";
import {
  generateDateRanges,
  valueCheckGlobalForFinancials,
  valueCheckGlobalNew,
} from "../../../GlobalFunctions";
import ComparisonChartModal from "../../../layout/modals/ComparisonChartModal";
import axios from "axios";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
// import { IconSearch } from '@tabler/icons-react';

const Auto = () => {
  const [company, setCompany] = useState("All Companies");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [frequency, setFrequency] = useState("monthly");
  const [parameter, setParameter] = useState("value");
  // const [growthValue, setGrowthValue] = useState(true);
  const [growth, setGrowth] = useState("MoM");
  const [cookies, setCookies, removeCookies] = useCookies();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [startDateOptions, setStartDateOptions] = useState([]);
  const [endDateOptions, setEndDateOptions] = useState([]);
  const [dates, setDates] = useState([]);
  // const [type, setType] = useState('');
  const [salestab, setSalesTab] = useState("sales");
  const [product, setProduct] = useState("All Products");
  const [category, setCategory] = useState("All Products");
  const [companyId, setCompanyId] = useState("");
  const [filter, setFilter] = useState([]);
  const [data, setData] = useState([]);
  const [startdatefield, setStartDateFeild] = useState("");
  const [chartActive, setChartActive] = useState(false);
  const [label, setLabel] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [chartData, setchartData] = useState([]);
  const [records, setRecords] = useState([]);

  const [timePeriod, setTimePeriod] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const icon = <IconChevronDown size={16} />;

  const [error, setError] = useState({
    startDateValue: "",
    endDateValue: "",
  });

  const [form, setForm] = useState({
    startDateValue: "",
    endDateValue: "",
  });

  const handleChange = (name, value) => {
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};

    if (!form.startDateValue) {
      newErrors.startDateValue = "Start date is required";
      isValid = false;
    }
    if (!form.endDateValue) {
      newErrors.endDateValue = "End date is required";
      isValid = false;
    }

    setError(newErrors);
    return isValid;
  };

  const handleChartModal = (company_name, label, chartData) => {
    setCompanyName(company_name);
    setLabel(label);
    setchartData(chartData);
    setChartActive(true);
  };

  const handleSubmit = () => {
    if (validateForm()) {
      setRecords([]);
      if (form.startDateValue > form.endDateValue) {
        setErrorMessage("Start date must be earlier than end date.");
        return false;
      }
      setErrorMessage("");

      if (form.startDateValue != "" && form.endDateValue != "") {
        setIsLoading(false);

        axios
          .post(`${baseUrl}/sector/autos`, {
            company: company,
            sdate: form.startDateValue,
            edate: form.endDateValue,
            salestab: salestab,
            category: category,
            parameter: parameter,
            frequency: frequency,
            growth: growth,
          })
          .then(function (response) {
            // console.log(response.data);
            setRecords(response.data);
            setIsLoading(true);
            const scrollContainer = scrollRef.current;
            if (scrollContainer) {
              scrollContainer.scrollLeft = scrollContainer.scrollWidth;
            }
          })
          .catch(function (error) {
            console.log("Error fetching data:", error);
          });
      }
    }
  };

  const handleExport = () => {
    const table = document.getElementById("cement-table");
    const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet 1" });
    XLSX.writeFile(wb, "Auto.xlsx");
  };

  function getThirteenMonthsBackRange(inputDate) {
    const startDate = new Date(inputDate); // make a copy for calculation
    const endDate = new Date(inputDate); // input date as start
    startDate.setMonth(endDate.getMonth() - 13); // subtract 13 months

    return {
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
    };
  }

  useEffect(() => {
    fetch(`${baseUrl}/sector/autos`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setFilter(data);
        // setProduct(data.product);
        // setType(data.type);
        setDates(data.dates);
        const default_date = getThirteenMonthsBackRange(
          data.dates.Autos.monthly[0].start_date
        );
        // console.log(default_date);
        handleChange("startDateValue", default_date.startDate);
        handleChange("endDateValue", default_date.endDate);
        setIsLoadingData(true);
        const scrollContainer = scrollRef.current;
        if (scrollContainer) {
          scrollContainer.scrollLeft = scrollContainer.scrollWidth;
        }
      });
  }, []);

  function generateStartAndEndDate() {
    const today = new Date();

    // Start date: 1 saal peechay ka current month ka first day
    const startDate = new Date(today.getFullYear() - 1, today.getMonth(), 1);

    // End date: is saal ka current month ka first day
    const endDate = new Date(today.getFullYear(), today.getMonth(), 1);

    return [
      startDate.toISOString().split("T")[0],
      endDate.toISOString().split("T")[0],
    ];
  }

  //////////////Default data ka liya hai
  useEffect(() => {
    if (
      form.startDateValue !== "" &&
      form.endDateValue !== "" &&
      !hasSubmitted
    ) {
      handleSubmit();
      setHasSubmitted(true); // taake dobara na chale
    }
  }, [form.startDateValue, form.endDateValue, hasSubmitted]);

  function getLabelByValue(typesArray, value) {
    const found = typesArray.find((item) => item.value === value);
    return found ? found.label : null;
  }
  useEffect(() => {
    if (!dates || !dates["Autos"]) {
      return;
    }

    var getType = "Autos"; //getLabelByValue(filter.type, type);

    var check_array = {
      MoM: "monthly",
      QoQ: "quarterly",
      HoH: "halfyearly",
      YoY: "CY",
    };
    let check = "";
    let datess = [];
    if (parameter == "growth") {
      check = growth;
      datess = dates[getType][check_array[growth]];
    } else if (parameter == "value") {
      check = frequency;
      datess = dates[getType][frequency];
    }

    setStartDateOptions(datess);
    setEndDateOptions(datess);
    if (check === "monthly" || check === "MoM") {
      setStartDate("Month Start");
      setEndDate("Month End");
    } else if (check === "quarterly" || check === "QoQ") {
      // setStartDateOptions(result['quarterlyDates']);
      // setEndDateOptions(result['quarterlyDates']);
      setStartDate("Quarterly Start");
      setEndDate("Quarterly End");
    } else if (check === "halfyearly" || check === "HoH") {
      // setStartDateOptions(result['halfYearlyDates']);
      // setEndDateOptions(result['halfYearlyDates']);
      setStartDate("HY Start");
      setEndDate("HY End");
    } else if (check === "CY" || check === "YoY") {
      // setStartDateOptions(result['calenderYearDates']);
      // setEndDateOptions(result['calenderYearDates']);
      setStartDate("CY Start");
      setEndDate("CY End");
    } else if (check === "FY" || check === "YoY") {
      // setStartDateOptions(result['fiscalYearDates']);
      // setEndDateOptions(result['fiscalYearDates']);
      setStartDate("FY Start");
      setEndDate("FY End");
    }
    // }
  }, [frequency, dates, parameter, growth]);

  useEffect(() => {
    const shouldReset =
      parameter === "growth" ||
      ["quarterly", "FY", "halfyearly", "CY"].includes(frequency);

    if (shouldReset) {
      setForm({
        startDateValue: "",
        endDateValue: "",
      });
    }
  }, [parameter, frequency]);

  const SelectItem = forwardRef(
    ({ image, label, company_name, ...others }, ref) => (
      <div ref={ref} {...others}>
        <Group noWrap>
          {/* <Avatar src={image} size="sm" /> */}
          <div>
            <Text size="sm">{label}</Text>
            <Text size="xs" opacity={0.65}>
              {company_name}
            </Text>
          </div>
        </Group>
      </div>
    )
  );

  const scrollRef = useRef(null);

  return (
    <>
      <Header />
      <div className="inflation-main analyst">
        <div className="row omcboxed sector-flex-line" style={styles.navWidth}>
          <Nav nopadding={true} />
        </div>

        <div className="omc-view container container_box">
          {isLoadingData ? (
            <>
              <div className="inflation-input-multi omc-multi-field">
                <Select
                  // label="Choose employee of the month"
                  placeholder="Search..."
                  itemComponent={SelectItem}
                  data={filter.company}
                  value={company}
                  // defaultValue={parseInt(companyId)}
                  // onSearchChange={handleSearchChange}
                  onChange={setCompany}
                  searchable
                  clearable
                  // limit={5}
                  className="search-field-stroke"
                  maxDropdownHeight={400}
                  nothingFound="Not Found"
                  filter={
                    (value, item) =>
                      item.label
                        .toLowerCase()
                        .includes(value.toLowerCase().trim())
                    // || item.company_name
                    //   .toLowerCase()
                    //   .includes(value.toLowerCase().trim())
                  }
                  // icon={<IconSearch size="1rem" />}
                  rightSection={<IconSearch size="1rem" />}
                  rightSectionWidth={30}
                  styles={{ rightSection: { pointerEvents: "none" } }}
                />
              </div>
              <div className="row m-auto">
                <div className="col-md-4 p-0">
                  <div className="view-type">
                    <span>Tab 1</span>
                  </div>
                  <div className="inflation-indices-box">
                    <div className="view-tabs-box radio_data1 radio_tabs12">
                      <SegmentedControl
                        value={salestab}
                        onChange={setSalesTab}
                        data={[
                          { label: "Sales", value: "sales" },
                          { label: "Production", value: "production" },
                        ]}
                        styles={{
                          control: {
                            "&:first-of-type": {
                              borderLeft:
                                "1px solid rgb(57 109 213 / 50%) !important",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-8 product-tabs-box">
                  <div className="view-type">
                    <span>Type</span>
                  </div>
                  <div className="inflation-indices-box">
                    <div className="view-tabs-box radio_data1 radio_tabs12">
                      <SegmentedControl
                        value={category}
                        onChange={setCategory}
                        data={filter.category}
                        styles={{
                          control: {
                            "&:first-of-type": {
                              borderLeft:
                                "1px solid rgb(57 109 213 / 50%) !important",
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12 pl-0 fertilizer-box-top">
                  <div className="view-type">
                    <span>Parameter</span>
                  </div>
                  <div className="inflation-indices-box">
                    <div className="view-tabs-box1 radio_data1 radio_tabs12 select_parameter">
                      <SegmentedControl
                        value={parameter}
                        onChange={setParameter}
                        data={[
                          { label: "Value", value: "value" },
                          { label: "Growth", value: "growth" },
                        ]}
                        styles={{
                          control: {
                            "&:first-of-type": {
                              borderLeft:
                                "1px solid rgb(57 109 213 / 50%) !important",
                            },
                          },
                        }}
                      />
                      {parameter === "growth" && (
                        <SegmentedControl
                          value={growth}
                          onChange={setGrowth}
                          data={[
                            { label: "MoM", value: "MoM" },
                            { label: "QoQ", value: "QoQ" },
                            { label: "HoH", value: "HoH" },
                            { label: "YoY", value: "YoY" },
                          ]}
                          styles={{
                            control: {
                              "&:first-of-type": {
                                borderLeft:
                                  "1px solid rgb(57 109 213 / 50%) !important",
                              },
                            },
                          }}
                        />
                      )}
                    </div>
                    {parameter === "value" && (
                      <div className="view-tabs-box radio_data1 radio_tabs12">
                        <SegmentedControl
                          value={frequency}
                          onChange={setFrequency}
                          data={[
                            { label: "Monthly", value: "monthly" },
                            { label: "Quarterly", value: "quarterly" },
                            { label: "Half Yearly", value: "halfyearly" },
                            { label: "CY", value: "CY" },
                            { label: "FY", value: "FY" },
                          ]}
                          styles={{
                            control: {
                              "&:first-of-type": {
                                borderLeft:
                                  "1px solid rgb(57 109 213 / 50%) !important",
                              },
                            },
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="cement-slt-field">
                  <Select
                    placeholder={startDate}
                    value={form.startDateValue}
                    label="Start date"
                    onChange={(value) => handleChange("startDateValue", value)}
                    data={startDateOptions}
                    rightSection={icon}
                    error={error.startDateValue}
                    className="select-dta-field"
                  />
                  <Select
                    placeholder={endDate}
                    value={form.endDateValue}
                    label="End date"
                    onChange={(value) => handleChange("endDateValue", value)}
                    data={endDateOptions}
                    rightSection={icon}
                    error={error.endDateValue}
                    className="select-dta-field"
                  />
                </div>
                <div className="search-clear-button align-items-start cement-search-btn">
                  <Button className="search-btn-stle" onClick={handleSubmit}>
                    Search
                  </Button>
                  <Button
                    className="search-btn-stle clear-btn-stl"
                    onClick={() => {
                      setForm({ startDateValue: "", endDateValue: "" });
                    }}
                  >
                    Clear
                  </Button>
                  {errorMessage && (
                    <h1
                      style={{
                        color: "red",
                        marginTop: "10px",
                        fontSize: "14px",
                      }}
                    >
                      {errorMessage}{" "}
                    </h1>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div
              style={{ width: "100%", height: "100%", color: "#426fd7" }}
              className="main-loader d-flex flex-column justify-content-center align-items-center"
            >
              <img src={LoadingImage} style={{ height: "500px" }} />
            </div>
          )}
        </div>
        {isLoading ? (
          <>
            <div className="omc-view-txt inflation-data container container_box">
              <div className="omc-volume">
                <div className="omc-excel-volume inflation-excel-right">
                  <div className="omc-excel-down">
                    <span onClick={handleExport}>
                      Download
                      <div
                        dangerouslySetInnerHTML={{ __html: modal_excel_icon }}
                      />
                    </span>
                  </div>
                </div>
                <div
                  className="ask-table-format fertilizer-row scroll-table"
                  ref={scrollRef}
                >
                  <table
                    className="table fertilizer-table-fixed-row fertilizer-table-row"
                    id="cement-table"
                  >
                    <thead className="fixed-rows">
                      <tr>
                        <th style={styles.stickyColumn}>Product</th>
                        <th>Company</th>
                        <th>Category</th>
                        <th>&nbsp;</th>
                        {records.length
                          ? records[0][0]?.data.map((item, index) => (
                              <th key={index} className="right-align">
                                {item.year}
                              </th>
                            ))
                          : ""}
                      </tr>
                    </thead>
                    <tbody>
                      {records.length ? (
                        records.map((item, index) =>
                          item.map((item2, index2) => (
                            <tr
                              key={index}
                              className={item2.product == "Total" ? "bold" : ""}
                            >
                              <td
                                style={styles.stickyColumn}
                                className="sticky-column"
                              >
                                {item2.product}
                              </td>
                              <td>{item2.company}</td>
                              <td>{item2.category}</td>
                              <td>
                                <div className="chart-omc-row">
                                  <span
                                    style={styles.chart}
                                    onClick={() => {
                                      handleChartModal(
                                        item2.company,
                                        item2.product,
                                        item2.data
                                      );
                                    }}
                                  >
                                    <div
                                      style={{ cursor: "pointer" }}
                                      dangerouslySetInnerHTML={{
                                        __html: modal_chart_icon,
                                      }}
                                    />
                                  </span>
                                </div>
                              </td>
                              {item2.data.map((item3, index3) => (
                                <td
                                  key={index + "-" + index2 + "-" + index3}
                                  className="right-align"
                                >
                                  {valueCheckGlobalNew(item3.value, 2)}
                                </td>
                              ))}
                            </tr>
                          ))
                        )
                      ) : (
                        <>
                          <tr>
                            <td colSpan={3} className="text-center">
                              Record not found{" "}
                            </td>
                          </tr>
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {chartActive && (
              <ComparisonChartModal
                chartActive={chartActive}
                setChartActive={setChartActive}
                companyname={companyName}
                label={label}
                chartData={chartData}
                slice={false}
              />
            )}
          </>
        ) : (
          <div
            style={{ width: "100%", height: "100%", color: "#426fd7" }}
            className="main-loader d-flex flex-column justify-content-center align-items-center"
          >
            <img src={LoadingImage} style={{ height: "500px" }} />
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
  chart: {
    cursor: "pointer",
    float: "left",
    posiiton: "absolute",
    padding: "0px 10px 0 0px",
  },
  omcStateTxt: {
    color: "#1D4283",
    fontSize: "20px",
    marginTop: "40px",
  },
  weeklyData: {
    color: "#000",
    fontSize: "16px",
  },
  stickyColumn: {
    position: "sticky",
    left: "0px",
    zIndex: "1",
  },
};
export default Auto;
